import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/openAccount',
    meta: {
      title: '开户链接'
    }
  },
  {
    path: '/openAccount',
    name: 'openAccount',
    component: () => import('@/views/openAccount.vue'),
    meta: {
      title: '开户链接'
    }
  },
  {
    path: '/agent',
    name: 'agent',
    component: () => import('@/views/agent.vue'),
    meta: {
      title: '注册代理'
    }
  },
  {
    path: '/rule',
    name: 'rule',
    component: () => import('@/views/rule.vue'),
    meta: {
      title: '规则'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/admin/login.vue')
  },
  {
    path: '/admin',
    component: () => import('@/layout/index.vue'),
    redirect: "/login",
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/admin/dashboard.vue"),
        name: "dashboard",
        meta: { requiresAuth: true },
      },
      {
        path: "user",
        component: () => import("@/views/admin/user.vue"),
        name: "user",
        meta: { requiresAuth: true },
      },
      {
        path: "agent",
        component: () => import("@/views/admin/agent.vue"),
        name: "adminAgent",
        meta: { requiresAuth: true },
      },
      {
        path: "userType",
        component: () => import("@/views/admin/userType.vue"),
        name: "userType",
        meta: { requiresAuth: true },
      },
      {
        path: "thirdparty",
        component: () => import("@/views/admin/thirdparty.vue"),
        name: "thirdparty",
        meta: { requiresAuth: true },
      },
      {
        path: "bill",
        component: () => import("@/views/admin/bill.vue"),
        name: "bill",
        meta: { requiresAuth: true },
      },
      {
        path: "rule",
        component: () => import("@/views/admin/rule.vue"),
        name: "adminRule",
        meta: { requiresAuth: true },
      },
      {
        path: "points",
        component: () => import("@/views/admin/points.vue"),
        name: "points",
        meta: { requiresAuth: true },
      },
      {
        path: "blackList",
        component: () => import("@/views/admin/blackList.vue"),
        name: "blackList",
        meta: { requiresAuth: true },
      },
      {
        path: "contract",
        component: () => import("@/views/admin/contract.vue"),
        name: "contract",
        meta: { requiresAuth: true },
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('token')
    if (token) {
      next() // 已登录放行
    } else {
      next({
        path: '/login',
        //query: { redirect: to.fullPath } // 记录目标路径用于登录后跳转
      })
    }
  } else {
    next()
  }
  document.title = to.meta.title || '后台管理'
  // if (to.meta.title){
  //   document.title = to.meta.title || '后台管理'
  // }
})

export default router
